module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1055-6ddaf345e925c5313b14c8b9b711c8cb.png";